import { FC } from 'react';
import { DealWarrantyTerms } from './DealWarrantyTerms';

type DealWarrantyTermsPageProps = {};

export const DealWarrantyTermsPage: FC<DealWarrantyTermsPageProps> = () => {
  return <DealWarrantyTerms />;
};
